/**
 * Simple webpage schema for json+ld
 * @param {string} title
 */
export const getWebpageSchema = title => ({
  '@type': 'WebPage',
  name: title,
});
